import React from 'react'
import {
    AuthorContent,
    Card,
    Content,
    ImageSection,
    TitleTypography,
} from './styles'
import Author from 'src/assets/Blog/author.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
export const CardAuthor = () => {
    const t = useTranslations()
    return (
        <Card marginTop={'xxxmedium'}>
            <ImageSection src={Author} alt={'author'} />
            <AuthorContent marginTop={'xxmedium'}>
                <TitleTypography>Sebastian Bárcenas</TitleTypography>
            </AuthorContent>
            <AuthorContent marginTop={'medium'}>
                <Content>{t('blog.recentBlog.descriptionAuthor')}</Content>
            </AuthorContent>
        </Card>
    )
}
